import React, { useEffect, useState } from 'react'
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import ErrorDisplay from './ErrorDisplay'
import './TextEditor.scss'

const TextEditor = ({ value, name, onChange, label, height, errors, mode }) => {
	const [editorState, setEditorState] = useState(EditorState.createEmpty())

	useEffect(() => {
		if (value) {
			const contentBlock = htmlToDraft(value)
			if (contentBlock) {
				const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
				const newEditorState = EditorState.createWithContent(contentState)
				setEditorState(newEditorState)
			}
		} else {
			setEditorState(EditorState.createEmpty())
		}
	}, [value === undefined]) // Only run once or when value presence changes

	const onEditorStateChange = (newEditorState) => {
		setEditorState(newEditorState)
		const html = draftToHtml(convertToRaw(newEditorState.getCurrentContent()))
		onChange(name, html)
	}

	const toolbarConfig = {
		options: ['inline', 'list', 'link', 'history'],
		inline: {
			options: ['bold', 'italic', 'underline'],
		},
		list: {
			options: ['unordered', 'ordered'],
		},
		link: {
			options: ['link'],
		},
		history: {
			options: ['undo', 'redo'],
		},
	}

	return (
		<div className='flex flex-col' style={height && { minHeight: height + 'px' }}>
			{label && (
				<label className='font-light flex text-gray-700 text-sm mb-0.5'>
					{label}
				</label>
			)}
			<div className='native-text-editor-wrapper'>
				<Editor
					editorState={editorState}
					onEditorStateChange={onEditorStateChange}
					wrapperClassName="editor-wrapper"
					editorClassName="editor-content"
					toolbarClassName="editor-toolbar"
					toolbar={toolbarConfig}
					placeholder="Start typing..."
				/>
			</div>
			<ErrorDisplay error={errors} />
		</div>
	)
}

export default TextEditor
